import React from 'react'
import styled from 'styled-components'
import { TextField, FormGroup, Button, Card, CardContent, withStyles, SnackbarContent } from '@material-ui/core'

const styles = {
  card: {
    width: '500px',
    maxWidth: '100%',
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    marginBottom: 16,
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
}

const MainCard = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Login = props => {
  const { onLogin, onEmailChange, onPwdChange, email, pwd, classes, loading, error } = props

  return (
    <MainCard className="login">
      <Card className={classes.card}>
        <CardContent>
          {
            error &&
            <SnackbarContent
              message={ error }
            />
          }
          <FormGroup>
            <TextField
              id="email"
              label="Email"
              margin="normal"
              value={email}
              onChange={onEmailChange}
            />
          </FormGroup>
          <FormGroup>
            <TextField
              id="password"
              label="Password"
              type="password"
              autoComplete="current-password"
              margin="normal"
              value={pwd}
              onChange={onPwdChange}
            />
          </FormGroup>
          <FormGroup>
            <Button
              onClick={onLogin}
              variant="contained"
              disabled={loading}
              color="primary">
              Login
            </Button>
          </FormGroup>
        </CardContent>
      </Card>
    </MainCard>
  )
}

export default withStyles(styles)(Login)


// WEBPACK FOOTER //
// ./src/components/LoginField.jsx